import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=d8d3059e&scoped=true&"
import script from "./UploadForm.vue?vue&type=script&lang=js&"
export * from "./UploadForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadForm.vue?vue&type=style&index=0&id=d8d3059e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d3059e",
  null
  
)

export default component.exports